module.exports = __webpack_public_path__ + "static/media/Robotobold.1fc6a83d.ttf";